module.exports = __webpack_public_path__ + "images/p-value-02.webp";